import { useEffect } from 'react';

const SITE_NAME = 'VoltValue';

// UX-owy tytuł karty przeglądarki po nawigacji SPA (nie SEO — treść dla
// botów bez JS generuje osobny generator SSG po stronie backendu).
// Przywraca domyślny tytuł przy odmontowaniu, żeby nawigacja SPA nie
// zostawiała nieaktualnego title z poprzedniej strony.
// `false`: komponent osadzony w innej stronie (np. dobór w formularzu zlecenia) nie rusza tytułu jej karty.
const useDocumentTitle = (title) => {
  useEffect(() => {
    if (title === false) return undefined;
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    return () => { document.title = SITE_NAME; };
  }, [title]);
};

export default useDocumentTitle;
